type FeLabelMap = Record<string, string>

const feLabelMap: FeLabelMap = {
  Industry: 'Industrials',
}

export const getEquitySliderLabel = (value: string) => {
  if (value) {
    const formattedValue = value
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
    // Parse FE labels
    if (Object.prototype.hasOwnProperty.call(feLabelMap, formattedValue)) {
      return feLabelMap[formattedValue] // Return the corresponding value
    }

    return formattedValue // If not in map, return value from BE
  }

  return ''
}
